<template>
    <div class="image-uploader border p-2">
        <input type="file" @change="onFileChange" accept="image/*" style="display:none" ref="input">
        <div v-if="imgSrc">
            <img :src="imgSrc" class="img-fluid" alt="Uploaded image">
        </div>
        <div v-else>
            <a href @click.prevent="openUpload()">
                <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZGlzcGxheTpub25lO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMzAzMDMwO3N0cm9rZS13aWR0aDowLjc7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDJ7ZmlsbDojMzAzMDMwO30KPC9zdHlsZT48ZyBjbGFzcz0ic3QwIiBpZD0iUGFkZGluZ19feDI2X19BcnRib2FyZCIvPjxnIGlkPSJJY29ucyI+PGc+PGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iMjIuODQwNzQiIGN5PSIyNy43MjM4MyIgcj0iNC4yNTM5NCIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjIyLjg0MDc0IiBjeT0iMjcuNzIzODMiIHI9IjIuODA3NzgiLz48bGluZSBjbGFzcz0ic3QxIiB4MT0iMzQuNDExMSIgeDI9IjI2LjYxMzQ0IiB5MT0iMjUuNjYyMjgiIHkyPSIyNS42NjIyOCIvPjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIxOS4xMDcwNyIgeDI9IjExLjI3MDI0IiB5MT0iMjUuNjYyMjgiIHkyPSIyNS42NjIyOCIvPjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yNy42Njk3OCwxOS42ODgwMWgwLjE5NDQ2aDUuODc3MDRjMC4zNjczMiwwLDAuNjY5ODEsMC4zMDI1LDAuNjY5ODEsMC42Njk4MXY1LjMwNDQ2djkuNDA5NzUgICAgYzAsMC4zNzgxMi0wLjMwMjQ5LDAuNjgwNjEtMC42ODA2MSwwLjY4MDYxSDExLjk0MDA1Yy0wLjM2NzMyLDAtMC42Njk4MS0wLjMwMjQ5LTAuNjY5ODEtMC42Njk4MXYtOS40MjA1NnYtNS4zMTUyNyAgICBjMC0wLjM2NzMyLDAuMjkxNjktMC42NTkwMSwwLjY1OTAxLTAuNjU5MDFoNS44OTg2NWgwLjE4MzY2bDEuMzUwMjUtMi4zOTYyMWMwLjExMzU3LTAuMjAxNTUsMC4zMjY5Ni0wLjMyNjI0LDAuNTU4My0wLjMyNjI0ICAgIGg1Ljg0MTEzYzAuMjMxMzUsMCwwLjQ0NDczLDAuMTI0NjksMC41NTgzLDAuMzI2MjRMMjcuNjY5NzgsMTkuNjg4MDF6Ii8+PGxpbmUgY2xhc3M9InN0MSIgeDE9IjM0Ljc0OTE5IiB4Mj0iMzQuNzQ5MTkiIHkxPSIxMi4yNDczNSIgeTI9IjE2LjIwODUiLz48bGluZSBjbGFzcz0ic3QxIiB4MT0iMzIuNzY4NjIiIHgyPSIzNi43Mjk3NiIgeTE9IjE0LjIyNzkyIiB5Mj0iMTQuMjI3OTIiLz48L2c+PC9nPjwvc3ZnPg==" alt="add" class="img-fluid" width="100%">
            </a>
        </div>
        <div v-if="processUpload">
            <div class="progress" style="height: 3px;">
                <div class="progress-bar" role="progressbar" :style="progressBarStyles"></div>
            </div>
        </div>
        <div class="pt-3">
            <div v-if="processUpload">
                processing upload...
            </div>
            <div v-if="showDeleteLink">
                <button type="button" class="btn btn-outline-danger btn-sm btn-block"
                        @click.prevent="deleteImage"
                        :disabled="disabledDelete">
                    Delete image
                </button>
            </div>
        </div>
        <div ref="canvasContainer" class="canvasImage"></div><!-- hidden div to process canvas -->
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'

// https://codepen.io/csengineer13/pen/ZLWVBq
// https://hacks.mozilla.org/2011/01/how-to-develop-a-html5-image-uploader/

// Props
const props = defineProps({
  imgOptions: {
    type: Object,
    default: () => ({})
  },
  item: {
    type: Object,
    default: null
  },
  src: {
    type: String,
    default: null
  },
  deleteUrl: {
    type: String,
    default: null
  },
  uploadUrl: {
    type: String,
    default: null
  }
})

// Emits
const emit = defineEmits(['add-image', 'delete-image'])

// Refs
const input = ref(null)
const canvasContainer = ref(null)

// Reactive data
const options = ref({
    maxWidth: 600,
    maxHeight: 600,
    canvas: true,
    pixelRatio: window.devicePixelRatio,
    orientation: true
})

const id = ref(null)
const processUpload = ref(false)
const uploadPercentCompleted = ref(0)
const imgSrc = ref(null)
const imageDeleteUrl = ref(null)
const disabledDelete = ref(false)

// Computed
const showDeleteLink = computed(() => {
    return !!(imgSrc.value && !processUpload.value && imageDeleteUrl.value)
})

const progressBarStyles = computed(() => {
    return {
        width: uploadPercentCompleted.value + '%'
    }
})

// Methods
const openUpload = () => {
    input.value.click()
}

const onFileChange = (e) => {
    loadImage(
        e.target.files[0],
        function (img) {
            // Callback function
            canvasContainer.value.appendChild(img)
            imgSrc.value = img.toDataURL("image/jpeg")
            uploadImage()
        },
        options.value
    )
    input.value.value = null
}

const uploadImage = () => {
    if (!props.uploadUrl) {
        return false
    }

    processUpload.value = true

    const config = {
        onUploadProgress: (progressEvent) => {
            uploadPercentCompleted.value = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
    }

    const data = {
        image: imgSrc.value
    }

    axios.post(props.uploadUrl, data, config)
        .then(function (res) {
            imageDeleteUrl.value = props.deleteUrl.replace(':id', res.data.id)
            imgSrc.value = res.data.src
            id.value = res.data.id
            console.log('imageDeleteUrl', imageDeleteUrl.value)
            processUpload.value = false
            emit('add-image', res.data)
        })
        .catch(function (err) {
            console.log(err)
            processUpload.value = false
        })
}

const deleteImage = () => {
    if (!confirm('Are you sure ?')) {
        return
    }

    disabledDelete.value = true

    if (imageDeleteUrl.value) {
        axios.delete(imageDeleteUrl.value)
            .then(function (res) {
                console.log(res)
                imgSrc.value = null
                disabledDelete.value = false
                emit('delete-image')
            })
            .catch(function (err) {
                console.log(err)
                disabledDelete.value = false
            })
    }
}

// Lifecycle
onMounted(() => {
    imgSrc.value = props.item ? props.item.src : props.src
    id.value = props.item ? props.item.id : null
    imageDeleteUrl.value = props.deleteUrl.replace(':id', id.value)
    options.value = { ...options.value, ...props.imgOptions }
})
</script>

<style>
.canvasImage > canvas{
    display: none;
}
</style>
